@if (searchPreviewItem) {
  <li (mousedown)="$event.preventDefault()" (click)="onProductSearchResultClicked.emit()"
    class="d-flex p-2 search-preview-item">
    <div class="text-center image-container">
      <img class="w-max-48px h-max-48px object-position-center align-middle" [src]="searchPreviewItem.thumbnail" alt="searchPreviewEntry thumbnail">
    </div>
    <div class="ms-2">
      @if (searchPreviewItem.productIdentifier) {
        <b>{{ searchPreviewItem.productIdentifier.productNumber }}</b>
      }
      @if (searchPreviewItem.productIdentifier && searchPreviewItem.description) {
        -
      }
      @if (searchPreviewItem.description) {
        <b>{{ searchPreviewItem.description }}</b>
      }
    </div>
  </li>
}